import { atomFamily } from 'recoil';

const checkBoxStatusAtomFamily = atomFamily<boolean, string>({
  key: 'checkBoxStatusAtomFamily',
  default: false,
});

export { checkBoxStatusAtomFamily };
